// TODO: probably need to check all languages in navigator.languages, not just the first one
import {i18n} from '@lingui/core';
import {messages as enMessages} from '@i18n/dict/en/messages';
import {messages as ruMessages} from '@i18n/dict/ru/messages';
import type KeyVal from '@interfaces/keyVal';

const localeDict = {
    'en-US': enMessages as KeyVal<string>,
    'ru-RU': ruMessages as KeyVal<string>,
};

export function initTranslations() {
    i18n.load(localeDict);
    activateLocale(getDeviceLocale());
}

export function activateLocale(locale: string) {
    document.documentElement.setAttribute('lang', getLanguageFromLocale(locale));
    i18n.activate(locale);
}

export function getDeviceLocale(): string {
    const deviceLocales = window.navigator.languages.length
        ? [...window.navigator.languages]
        : [window.navigator.language];
    return chooseOptimalLocale(deviceLocales);
}

export function chooseOptimalLocale(inputLocales: string[]): string {
    const knownLocales = Object.keys(localeDict);

    for (const inputLocale of inputLocales) {
        for (const knownLocale of knownLocales) {
            if (
                inputLocale === knownLocale ||
                inputLocale.startsWith(knownLocale.substring(0, 2))
            ) {
                return knownLocale;
            }
        }
    }

    return knownLocales[0];
}

function getLanguageFromLocale(locale: string): string {
    return locale.split('-')[0];
}
